export const APP_BASE_URL =
  process.env.REACT_APP_ENV === 'local'
    ? 'http://localhost:3000'
    : window.location.origin;

export const APP_CONTACTS_API_BASE_URL = process.env
  .REACT_APP_CONTACTS_API_BASE_URL as string;

export const APP_NEXUS_API_BASE_URL = process.env
  .REACT_APP_NEXUS_API_BASE_URL as string;

export const APP_SETTINGS_API_BASE_URL = process.env
  .REACT_APP_SETTINGS_API_BASE_URL as string;
